import localforage from 'localforage'

export const getToken = () => {
  return localforage.getItem('access_token').then((value) => {
    return value
  }).catch(() => {
    return false
  })
}



// WEBPACK FOOTER //
// ./src/Services/GetToken.js